var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Toolbox Open 2",
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none",
    fill: "#2188ff",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.83 0 0 0.83 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 7.22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#2188ff",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-12, -19.22)",
    d: "M 9.6167 14.6868 L 0.75 14.6868 C 0.335786 14.6868 0 15.0226 0 15.4368 L 0 22.0265 C 0 22.981 0.773769 23.7548 1.72826 23.7548 L 22.2717 23.7548 C 23.2262 23.7548 24 22.981 24 22.0265 L 24 15.4368 C 24 15.0226 23.6642 14.6868 23.25 14.6868 L 14.3834 14.6868 L 14.3834 17.3008 C 14.3834 17.9329 14.1323 18.5391 13.6854 18.9861 C 13.2384 19.4331 12.6322 19.6842 12.0001 19.6842 C 11.368 19.6842 10.7617 19.4331 10.3148 18.9861 C 9.8678 18.5391 9.6167 17.9329 9.6167 17.3008 L 9.6167 14.6868 Z M 11.1167 17.3008 L 11.1167 14.7478 L 12.8834 14.7478 L 12.8834 17.3008 C 12.8834 17.5351 12.7904 17.7598 12.6247 17.9255 C 12.459 18.0911 12.2343 18.1842 12.0001 18.1842 C 11.7658 18.1842 11.5411 18.0911 11.3754 17.9255 C 11.2098 17.7598 11.1167 17.5351 11.1167 17.3008 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0.16 -4.31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "#2188ff",
      fillRule: "evenodd",
      opacity: 1
    },
    transform: " translate(-12.16, -7.69)",
    d: "M 6.37925 1.95241 C 6.29835 1.93839 6.21573 1.96498 6.1582 2.02356 C 6.10067 2.08213 6.07557 2.16522 6.09104 2.24585 L 6.68519 5.34176 L 5.6789 6.82527 L 4.19532 5.81895 L 3.60116 2.72297 C 3.58569 2.64237 3.53165 2.5745 3.45656 2.54137 C 3.38147 2.50824 3.2949 2.51407 3.22494 2.55698 C 2.43809 3.03956 1.81694 3.7504 1.4442 4.59484 C 1.07146 5.43928 0.964831 6.37723 1.1385 7.28379 C 1.31218 8.19035 1.75791 9.02248 2.41635 9.66937 C 3.03332 10.2755 3.80959 10.6921 4.65315 10.8718 L 5.14419 13.4368 L 8.74482 13.4368 L 8.1252 10.2063 C 8.8426 9.72756 9.40996 9.05362 9.75922 8.26238 C 10.132 7.41794 10.2386 6.47999 10.0649 5.57343 C 9.89124 4.66687 9.4455 3.83474 8.78707 3.18785 C 8.12863 2.54096 7.28874 2.11001 6.37925 1.95241 Z M 18.2834 13.4368 L 14.8266 13.4368 L 15.9057 7.64539 L 11.9234 6.90337 C 11.8582 6.89122 11.8006 6.85366 11.763 6.79897 C 11.7255 6.74427 11.7113 6.67691 11.7235 6.61172 L 12.0808 4.69789 C 12.1061 4.56219 12.2366 4.47271 12.3723 4.49799 C 14.481 4.89091 15.8496 3.96326 16.0665 2.79922 C 16.0918 2.66349 16.2223 2.57396 16.358 2.59924 L 23.0586 3.84711 C 23.1238 3.85925 23.1815 3.89679 23.219 3.95147 C 23.2565 4.00615 23.2707 4.07349 23.2586 4.13867 L 22.4262 8.60605 C 22.4009 8.74179 22.2703 8.83132 22.1346 8.80603 L 19.3021 8.27824 L 18.2834 13.4368 Z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbox);
export default __webpack_public_path__ + "static/media/toolbox.3df3bf4704aec59f63e6bb02c1b7300a.svg";
export { ForwardRef as ReactComponent };